import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';
import moment from 'moment';

const state = {
    razonSocial: '',
    nombreComercial: '',
    paisId: 0,
    pais: '',
    direccion: '',
    sucursalTitulo: '',
    sucursalDireccion: '',
    telefono: '',
    email: '',
    emailProveedores: '',
    condicionFiscal: '',
    tipoDocumento: '',
    documentoNumero: '',
    // cuit: '',
    ingresosBrutos: '',
    fechaInicioActividades: '1900-01-01',
    fechaInicioActividadesHabilitada: false,
    inicioActividades: '',
    website: '',
    logo: '',
    instagram: '',
    instagramUrl: '',
    logoInstagram: '',
    linkedin: '',
    linkedinUrl: '',
    logoLinkedin: '',
    logoWeConnect: '',
    logoEcovadis: '',
    cbu: '',
    cbuAlias: '',
    rowVersion: null,

    imagenColorR: 232,
    imagenColorG: 67,
    imagenColorB: 113,

    moneda: ''
};

const mutations = {
    updateField,

    'SET_EMPRESA'(state, empresa) {
        state.razonSocial = empresa.razonSocial.trim();
        state.nombreComercial = empresa.nombreComercial.trim();
        state.paisId = empresa.paisId;
        state.pais = empresa.pais? empresa.pais.trim() : '';
        state.direccion = empresa.direccion.trim();
        state.sucursalTitulo = empresa.sucursalTitulo.trim();
        state.sucursalDireccion = empresa.sucursalDireccion.trim();
        state.telefono = empresa.telefono.trim();
        state.email = empresa.email.trim();
        state.emailProveedores = empresa.emailProveedores.trim();
        state.condicionFiscal = empresa.condicionFiscal.trim();
        state.tipoDocumento = empresa.tipoDocumento.trim();
        state.documentoNumero = empresa.documentoNumero.trim();
        // state.cuit = empresa.cuit.trim();
        state.ingresosBrutos = empresa.ingresosBrutos.trim();
        state.fechaInicioActividades = moment(empresa.fechaInicioActividades).format('YYYY-MM-DD');
        if (moment(empresa.fechaInicioActividades).format('YYYY-MM-DD') == '1900-01-01') {
            state.fechaInicioActividadesHabilitada = false;
            state.inicioActividades = '';
        } else {
            state.fechaInicioActividadesHabilitada = true;
            state.inicioActividades = moment(empresa.fechaInicioActividades).format('MM/YYYY');
        }
        state.website = empresa.website.trim();
        state.logo = empresa.logo.trim();
        state.cbu = empresa.cbu.trim();
        state.cbuAlias = empresa.cbuAlias.trim();
        state.instagram = empresa.instagram.trim();
        state.instagramUrl = empresa.instagramUrl.trim();
        state.logoInstagram = empresa.logoInstagram.trim();
        state.linkedin = empresa.linkedin.trim();
        state.linkedinUrl = empresa.linkedinUrl.trim();
        state.logoLinkedin = empresa.logoLinkedin.trim();
        state.logoWeConnect = empresa.logoWeConnect.trim();
        state.logoEcovadis = empresa.logoEcovadis.trim();
        state.rowVersion = empresa.rowVersion;

        switch (state.paisId) {
            case 1: /* Argentina */
                state.moneda = 'pesos argentinos';
                break;
            case 5: /* Chile */
                state.moneda = 'pesos chilenos';
                break;
            default:
                state.moneda = 'pesos';
                break;
        }

        /* Colores principales de la imagen de la empresa */
        state.imagenColorR = empresa.imagenColorR;
        state.imagenColorG = empresa.imagenColorG;
        state.imagenColorB = empresa.imagenColorB;
    },
};

const getters = {
    getField,

    empresa (state) {
        let empresa = {
            razonSocial: state.razonSocial,
            nombreComercial: state.nombreComercial,
            paisId: state.paisId,
            pais: state.pais,
            direccion: state.direccion,
            sucursalTitulo: state.sucursalTitulo,
            sucursalDireccion: state.sucursalDireccion,
            telefono: state.telefono,
            email: state.email,
            emailProveedores: state.emailProveedores,
            condicionFiscal: state.condicionFiscal,
            tipoDocumento: state.tipoDocumento,
            documentoNumero: state.documentoNumero,
            // cuit: state.cuit,
            ingresosBrutos: state.ingresosBrutos,
            fechaInicioActividades: state.fechaInicioActividades,
            inicioActividades: state.inicioActividades,
            website: state.website,
            logo: state.logo,
            instagram: state.instagram,
            instagramUrl: state.instagramUrl,
            logoInstagram: state.logoInstagram,
            linkedin: state.linkedin,
            linkedinUrl: state.linkedinUrl,
            logoLinkedin: state.logoLinkedin,
            logoWeConnect: state.logoWeConnect,
            logoEcovadis: state.logoEcovadis,
            cbu: state.cbu,
            cbuAlias: state.cbuAlias,
            rowVersion: state.rowVersion,
            
            moneda: state.moneda,

            imagenColorR: state.imagenColorR,
            imagenColorG: state.imagenColorG,
            imagenColorB: state.imagenColorB,
        }
        return empresa;
    },
};

const actions = {
    inicializar ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('empresas' ) 
                .then(res => {
                    commit('SET_EMPRESA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let fechaInicioActividades = '1900-01-01';
            if ((/true/i).test(state.fechaInicioActividadesHabilitada)) {
                fechaInicioActividades = moment(state.fechaInicioActividades).format('YYYY-MM-DD');
            }
            
            let empresa= {
                nombreComercial: state.nombreComercial.toUpperCase().trim(),
                razonSocial: state.razonSocial.toUpperCase().trim(), 
                direccion: state.direccion.toUpperCase().trim(),
                sucursalTitulo: state.sucursalTitulo.toUpperCase().trim(),
                sucursalDireccion: state.sucursalDireccion.toUpperCase().trim(),
                telefono: state.telefono.toUpperCase().trim(),
                email: state.email.toLowerCase().trim(),
                emailProveedores: state.emailProveedores.toLowerCase().trim(),
                condicionFiscal: state.condicionFiscal.trim(),
                tipoDocumento: state.tipoDocumento.trim(),
                documentoNumero: state.documentoNumero.trim(),
                // cuit: state.cuit.trim(),
                ingresosBrutos: state.ingresosBrutos.trim(),
                fechaInicioActividades: fechaInicioActividades,
                website: state.website,
                cbu: state.cbu.toLowerCase().trim(),
                cbuAlias: state.cbuAlias.toLowerCase().trim(),
                rowVersion: state.rowVersion
            }

            let url = 'empresas';

            apiAxios.post(url, empresa)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}